import { globalSettingsCollectionName } from "./database-strings";
import { hasOwnProperty } from "@glideapps/ts-necessities";
import { Database } from "./Database";

const spotlightUIDocumentName = `spotlight-ui`;

export interface SpotlightUI {
    readonly newComponents: readonly string[];
}

function isSpotlightUI(x: unknown): x is SpotlightUI {
    return typeof x === "object" && hasOwnProperty(x, "newComponents") && Array.isArray(x.newComponents);
}

export async function getSpotlightUI(db: Database): Promise<SpotlightUI | undefined> {
    const untyped = await db.getDocument(globalSettingsCollectionName, spotlightUIDocumentName);
    if (!isSpotlightUI(untyped)) return undefined;
    return untyped;
}
